import { useTranslation } from 'react-i18next';
import { PartialDelivery } from '@/types';
import { formatDateByDayjs } from '@/utils';

/**
 * BOXY-378 — the order page badge text: "Was partially delivered — 2 of 3
 * items, 12 Sep". Counts are left out when the partial recorded none; null
 * when the order was never partially delivered.
 */
const usePartialDeliveryLabel = (partial?: PartialDelivery | null): string | null => {
  const { t } = useTranslation();

  if (!partial?.at) return null;

  const date = formatDateByDayjs(partial.at, 'D MMM');
  const counts =
    partial.unit && partial.delivered !== null && partial.total !== null
      ? String(
          t(`partial_marker_${partial.unit}`, {
            delivered: partial.delivered,
            total: partial.total,
          }),
        )
      : null;

  return `${String(t('partial_marker_was'))} — ${counts ? `${counts}, ` : ''}${date}`;
};

export default usePartialDeliveryLabel;
